export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://postly-api-9bfbb275d53e.herokuapp.com/api";
